// extracted by mini-css-extract-plugin
module.exports = {"list":"ScrapModal_list__3aVO2","amountToScrap":"ScrapModal_amountToScrap__1gPVz","availableBalance":"ScrapModal_availableBalance__12Y7Y","counter":"ScrapModal_counter__2u88K"};